import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
const FocusTrap = ({ children, isActive }) => {
    const container = useRef();
    const topTabTrap = useRef();
    const bottomTabTrap = useRef();
    useEffect(() => {
        document.addEventListener('focusin', trapFocus);
        return () => document.removeEventListener('focusin', trapFocus);
        function trapFocus(event) {
            if (!isActive)
                return;
            let elements;
            if (event.target === topTabTrap.current) {
                elements = getFocusableElements();
                if (elements.length > 0) {
                    const lastElement = elements[elements.length - 1];
                    lastElement.focus();
                }
            }
            if (event.target === bottomTabTrap.current) {
                elements = getFocusableElements();
                if (elements.length > 0) {
                    const firstElement = elements[0];
                    firstElement.focus();
                }
            }
        }
        function getFocusableElements() {
            if (!container.current)
                return [];
            const FOCUSABLE_SELECTOR = [
                'button',
                'a[href]',
                'input',
                'select',
                'textarea',
                '[tabindex]',
            ]
                .map((selector) => `${selector}:not(:disabled):not([disabled])`)
                .join(', ');
            return Array.from(container.current.querySelectorAll(FOCUSABLE_SELECTOR))
                .filter((element) => element !== topTabTrap.current)
                .filter((element) => element !== bottomTabTrap.current);
        }
    }, [isActive, topTabTrap, bottomTabTrap, container]);
    return (_jsxs("div", { className: "h-full", ref: container, children: [isActive && _jsx("span", { ref: topTabTrap, tabIndex: "0" }), children, isActive && _jsx("span", { ref: bottomTabTrap, tabIndex: "0" })] }));
};
export default FocusTrap;
